(function () {
  'use strict';

  function track(name, payload) {
    if (typeof window.ecTrack === 'function') window.ecTrack(name, payload || {});
  }

  function scrollToPurchase(source) {
    var purchase = document.getElementById('ec-primary-purchase');
    if (!purchase) return;
    track('ec_final_cta_click', {
      module_id: source || 'EC-MOD-0009',
      destination: 'ec-primary-purchase'
    });
    var top = purchase.getBoundingClientRect().top + window.scrollY - 92;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    purchase.setAttribute('tabindex', '-1');
    window.setTimeout(function () { purchase.focus({ preventScroll: true }); }, reduced ? 0 : 450);
  }

  function initRoot(root) {
    if (root.dataset.ecResinFunnelReady === 'true') return;
    root.dataset.ecResinFunnelReady = 'true';

    root.querySelectorAll('[data-ec-return-to-offer]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        event.preventDefault();
        var module = control.closest('[data-ec-module]');
        scrollToPurchase(module ? module.getAttribute('data-ec-module') : 'EC-MOD-0009');
      });
    });

    root.querySelectorAll('[data-ec-proof-open]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('ec_proof_opened', { module_id: 'EC-MOD-0002', evidence_type: 'laboratory_report' });
      });
    });

    root.querySelectorAll('[data-ec-format-compare]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('ec_format_compare_click', { module_id: 'EC-MOD-0007', selected_format: 'capsules' });
      });
    });

    root.querySelectorAll('[data-ec-resin-faq]').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        track('ec_faq_open', {
          module_id: 'EC-MOD-0008',
          faq_number: item.querySelector('summary span') ? item.querySelector('summary span').textContent.trim() : null
        });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ec-resin-funnel]').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
